import Carousel from './Carousel';
import ArtistsCarousel from './ArtistsCarousel';
import TracksCarousel from './TracksCarousel';

export default Carousel;
export { ArtistsCarousel, TracksCarousel };
